import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Koşullu class birleştirme + Tailwind çakışma çözümü. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
